import { Tabs, Tab } from "@heroui/tabs";
import { useState, useEffect } from "react";

const TabsComp = ({ items = [], selectedKey, defaultKey, onChange }) => {
const isControlled = selectedKey !== undefined;
const [internal, setInternal] = useState(defaultKey || items[0]?.key);

useEffect(() => {
  if (!isControlled && defaultKey) setInternal(defaultKey);
}, [defaultKey, isControlled]);

const currentKey = isControlled ? selectedKey : internal;

const handleSelection = (key) => {
  const k = String(key);
  if (!isControlled) setInternal(k);
  onChange?.(k);
};

return (
<Tabs
  size="md"
  selectedKey={currentKey}
  onSelectionChange={handleSelection}
  radius="full"
  variant="bordered"
  color="primary"
  className="pointer-events-auto"
  classNames={{
    tabList:
      "bg-white/80 dark:bg-zinc-900/80 backdrop-blur-sm border border-white/30 dark:border-white/10 p-1 rounded-full shadow-lg",
    // make unselected text not muted; keep selected as foreground
    tabContent: "text-foreground data-[selected=false]:text-foreground",
  }}
>
  {items.map(({ key, title }) => (
    <Tab key={key} title={title} />
  ))}
</Tabs>
);
};

export default TabsComp;